module.exports = __webpack_public_path__ + "static/media/edenredlogo.4ca29393.png";